<template>
  <div></div>
</template>

<script>
import * as API from '../utils/apiService'
import { getUserInfo } from '../utils/cache'

export default {
  mounted () {
    this.asyncGotoMoNPage()
  },
  methods: {
    asyncGotoMoNPage () {
      let params = {
        userid: getUserInfo().id
      }
      return API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          if (resp.data) {
            if (resp.data.memberno) {
              // 有数据有编号
              this.$router.push('/')
            } else if (resp.data.status === '1') {
              // 有数据没编号且状态为已处理
              this.$router.push('/notMemberIndex')
            } else if (resp.data.status === '3') {
              // 有数据没编号且状态为暂存
              this.$router.push('/applicationInfo')
            } else {
              this.$router.push('/progress') // 有数据没编号且状态为未处理
            }
          } else {
            this.$router.push('/applicationInfo')
          }
        }
      })
    }
  }
}
</script>
